import './ErrorMessage.css'
import * as React from 'react'

const ErrorMessage = (props:{text:string|React.ReactNode})=>(
  <div className='ErrorMessageAlert'>{props.text}</div>
)

export default ErrorMessage
